import { SelectionChangedEvent } from "ag-grid-community";
import _ from "lodash";
import { INITIAL_RECAL_PROCESS_AND_GEN_SUBMIT_COL_DEF, transferRowData } from "presentation/constant/Recalculation/RecalProcessAndGenSubmitColumnDefinition";
import { useRecalProcessAndGenVM } from "presentation/hook/Recalculation/useRecalProcessAndGenVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useRecalProcessAndGenMaintenanceTracked } from "presentation/store/Recalculation/RecalProcessAndGenMaintenanceProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { HPHButton, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const RecalProcessAndGenSubmitPanel = () => {
    const [recalProcessAndGenState] = useRecalProcessAndGenMaintenanceTracked();
    const recalProcessAndGenVM = useRecalProcessAndGenVM();
    const { recalProcessAndGenSubmitList, isShowSubmitEditPanel, selectSubmitRows, searchCriteria } = recalProcessAndGenState;
    const [isLoading, setIsLoading] = useState(false);
    const messageBarVM = useMessageBarVM();
    const gridRef: any = useRef(null);


    const handleSubmit = useCallback(async () => {
        if (_.isEmpty(recalProcessAndGenSubmitList)) {
            messageBarVM.showError("No record found.");
            return;
        }
        setIsLoading(true);
        await recalProcessAndGenVM.onSubmit(recalProcessAndGenSubmitList).then(async data => {
            if (data && data.success) {
                await recalProcessAndGenVM.onSearch(searchCriteria).then(data => {
                    setIsLoading(false);
                    messageBarVM.showSuccess("Submit Successfully.");
                })
            } else {
                setIsLoading(false);
                messageBarVM.showError(data.data ?? "Submit Failed.");
                return;
            }
        });
    }, [messageBarVM, recalProcessAndGenSubmitList, recalProcessAndGenVM, searchCriteria]);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        recalProcessAndGenVM.updateSelectedSubmitRows(selectedRows);
    }, [recalProcessAndGenVM])

    const handClose = useCallback(() => {
        recalProcessAndGenVM.onCloseSubmitPanel();
    }, [recalProcessAndGenVM]);

    const handEdit = useCallback(() => {
        if (!_.isEmpty(selectSubmitRows) && selectSubmitRows.length === 1) {
            recalProcessAndGenVM.onEditSubmitPanel(selectSubmitRows[0]);
        } else {
            messageBarVM.showError("Please select a record.");
            return;
        }
    }, [messageBarVM, recalProcessAndGenVM, selectSubmitRows]);

    const memoBtns = useMemo(() => {

        const hdrBtns = [];
        if (!isShowSubmitEditPanel) {
            hdrBtns.push({
                id: 'onEditButton',
                icon: 'Icon-pen',
                title: 'Edit'
            })
        }
        return hdrBtns
    }, [isShowSubmitEditPanel])

    const isRowSelectable = useCallback((params: any) => {
        return !isShowSubmitEditPanel;
    }, [isShowSubmitEditPanel]);

    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='recal-process-and-gen-submit-table'
                isNewColumnSetting={true}
                columns={INITIAL_RECAL_PROCESS_AND_GEN_SUBMIT_COL_DEF}
                data={transferRowData(recalProcessAndGenSubmitList ?? [])}
                showPaginator={false}
                headerActionButtons={memoBtns}
                onEditButton={handEdit}
                editable={false}
                showUploadIcon={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"single"}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                gridHeight="customHeight"
                customHeight="calc(100vh - 500px)"
                ref={gridRef}
                handleRowSelectable={isRowSelectable}
            />
        );
    }, [handEdit, handleSelectionChange, isRowSelectable, memoBtns, recalProcessAndGenSubmitList])


    useEffect(() => {
        if (gridRef.current && gridRef.current.gridRef && gridRef.current.gridRef.current && gridRef.current.gridRef.current.api) {
            gridRef.current.gridRef.current.api.redrawRows();
        }
    }, [isShowSubmitEditPanel])

    return (
        <div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>
                            {/*isSubmitAll ? "Submit All" : "Submit"*/"Submit Recalculation"}
                        </SidebarTitle>
                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" disabled={isShowSubmitEditPanel} toolTipText='Close' toolTipArrow={false} onClick={handClose} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>
            {isLoading &&
                <Loader Indicator="Spinner" size="Medium" />}
            <div style={{ maxHeight: '75vh', height: '75vh', overflow: 'auto' }}>
                {!isLoading && <>
                    <TableWrapper>
                        {memoTable}
                    </TableWrapper>
                </>}
            </div>
            <SidebarActionBar>
                {!isShowSubmitEditPanel && <>
                    {/* <HPHButton label={'Close'} size={'Small'} theme={'Secondary'} onClick={handClose} /> */}
                    <HPHButton label={'Submit'} size={'Small'} theme={'Primary'} onClick={handleSubmit} />
                </>}
            </SidebarActionBar>
        </div>
    );
}

export default RecalProcessAndGenSubmitPanel;
